module.exports = __webpack_public_path__ + "e1215b7f71b37c9a464001e9d80e7f37.svg";